import { createSelector } from 'reselect'

export {
  PermissionTargets,
  UserRoles,
  UserRolesNames,
  UserRolesDescriptions,
  UserRolesPermissions,
} from 'common/userRoles/constants/UserRoles'
import { sortUsersByUserRole } from 'common/userRoles/userRolesHelpers'

import { getAccountUsers } from './userRolesSelectors'

export const getSortedPaidUsersByUserRole = createSelector([getAccountUsers], (users) => {
  const inboxUsers = (users || []).filter((user) => user.is_inbox_user)
  return sortUsersByUserRole(inboxUsers)
})

export const getPaidUsersWithoutLimits = createSelector(
  [getSortedPaidUsersByUserRole],
  (paidUsers) => {
    return paidUsers?.filter((user) => user.threads_limit === null)
  },
)

export const getPaidUsersWithLimits = createSelector(
  [getSortedPaidUsersByUserRole],
  (paidUsers) => {
    return paidUsers?.filter((user) => user.threads_limit !== null)
  },
)

export const getIsAutoAssignmentEnabledForAllUsersWithLimits = createSelector(
  [getPaidUsersWithLimits],
  (users) => Boolean(users?.length && users.every((user) => user.lc_auto_assign_enabled)),
)

export const getDoAllUsersHaveNoLimits = createSelector(
  [getPaidUsersWithoutLimits, getSortedPaidUsersByUserRole],
  (usersWithoutLimits, users) =>
    Boolean(usersWithoutLimits?.length && usersWithoutLimits?.length === users?.length),
)
